import { Shape } from 'diagram-js/lib/model';

export const CANVAS_MARGIN = 10;

export class ROI {
  minX?: number;
  minY?: number;
  width?: number;
  height?: number;
}

export class Range {
  constructor(public start: number, public size: number) {
  }
  get end() {
    return this.start + this.size;
  }
}

export class DimensionsCalculator {

  public computeFittingBoxOfNodes(shapes: Array<Shape>): ROI {
    let maxX = Number.MIN_SAFE_INTEGER;
    let maxY = Number.MIN_SAFE_INTEGER;
    const roi: ROI = { minX: Number.MAX_SAFE_INTEGER, minY: Number.MAX_SAFE_INTEGER};
    shapes
      .forEach(element => {
        roi.minX = Math.min(roi.minX, element.x);
        roi.minY = Math.min(roi.minY, element.y);
        maxY = Math.max(maxY, element.y + element.height);
        maxX = Math.max(maxX, element.x + element.width);
      });

    roi.minX -= CANVAS_MARGIN;

    roi.width = maxX - roi.minX + CANVAS_MARGIN;
    roi.height = maxY - roi.minY;

    return roi;
  }

  public doesRangeContainAnother(internal: Range, external: Range): boolean {
    return internal.start >= external.start && internal.end <= external.end;
  }
  
  public doesViewBoxContainROI(roi: ROI, viewBox): boolean {
    return this.doesRangeContainAnother(new Range(roi.minX, roi.width), new Range(viewBox.x, viewBox.width)) &&
      this.doesRangeContainAnother(new Range(roi.minY, roi.height), new Range(viewBox.y, viewBox.height));
  }

  public centralizeOnAxis(inner: Range, containerSize: number) {
    if (containerSize <= inner.size) {
      return inner.start;
    }
    return inner.start - (containerSize - inner.size) / 2;
  }

  public willItFit(roi: ROI, viewbox: ROI): boolean {
    return (
      (roi.height <= viewbox.height)
      &&
      (roi.width <= viewbox.width)
    );
  }

}
